export default __webpack_public_path__ + "static/media/bernay4.51d8af3e.jpg";